export default __webpack_public_path__ + "static/media/cleric.f0331430.jpeg";